import { createFileRoute } from '@tanstack/react-router';

import { OrderDetailPage } from '@/features/procurement/order-detail-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/orders/$poId')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <OrderDetailPage {...params} />;
}
